import React from 'react';
import Row from './Row';

const RowWrapper = ({ rowIndex }: { rowIndex: number }) => {
  return <Row rowIndex={rowIndex} />;
};

export default React.memo(RowWrapper);
